import NewsTipSimpleForm from './NewsTipSimpleForm'

export default NewsTipSimpleForm
